import { render, staticRenderFns } from "./QuotationSsuOrder.vue?vue&type=template&id=5b856dc8&scoped=true"
import script from "./QuotationSsuOrder.vue?vue&type=script&lang=js"
export * from "./QuotationSsuOrder.vue?vue&type=script&lang=js"
import style0 from "./QuotationSsuOrder.vue?vue&type=style&index=0&id=5b856dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b856dc8",
  null
  
)

export default component.exports